export const AnalyticsCategory = {
  account: 'account',
  user_authentication: 'user_authentication',
  cta_click: 'cta_click',
  cta_hover: 'cta_hover',
  page_load_time: 'page_load_time',
  total_objectives_in_view: 'total_objectives_in_view',
  team_selected: 'team_selected',
  cycle_selected: 'cycle_selected',
  filter_applied: 'filter_applied',
  real_time_events: 'real_time_events',
  service_worker: 'service_worker',
  jira_integration: 'jira_integration',
  drag_and_drop: 'drag_and_drop',
  userboard: 'userboard',
  level_filter: 'level_filter',
  feature_panel: 'feature_panel',
  milestones: 'milestones',
  teams_quick_filters: 'teams_quick_filters',
  execution_times: 'execution_times',
  annual_goals: 'annual_goals',
  lock_edits: 'lock_edits',
  export_current_view: 'export_current_view',
  api_requests: 'api_requests'
};

export const AnalyticsAction = {};

export const AnalyticsLabel = {};

export const AnalyticsValue = {};

export const getDefaultLabelString = () =>
  `${window.location.pathname}?${window.location.search}`.toLowerCase();

export const getFilterActionString = filters => {
  const filtersAnalyticsArray = [];
  if (
    filters &&
    (filters.owners ||
      filters.teams ||
      filters.status ||
      filters.objectives ||
      filters.label_ids ||
      filters.due_date)
  ) {
    if (filters.owners && filters.owners.length > 0)
      filtersAnalyticsArray.push('owners');
    if (filters.teams && filters.teams.length > 0)
      filtersAnalyticsArray.push('teams');
    if (filters.status && filters.status.length > 0)
      filtersAnalyticsArray.push('status');
    if (filters.objectives && filters.objectives.length > 0)
      filtersAnalyticsArray.push('objectives');
    if (filters.label_ids && filters.label_ids.length > 0)
      filtersAnalyticsArray.push('label_ids');
    if (filters.due_date) filtersAnalyticsArray.push('due_date');
  }
  return `Filter?${filtersAnalyticsArray.join('&')}`.toLowerCase();
};

export const getFilterLabelString = filters => {
  const filtersAnalyticsArray = [];
  if (
    filters &&
    (filters.owners ||
      filters.teams ||
      filters.status ||
      filters.objectives ||
      filters.label_ids ||
      filters.due_date)
  ) {
    if (filters.owners && filters.owners.length > 0)
      filtersAnalyticsArray.push(`owners=${filters.owners.length}`);
    if (filters.teams && filters.teams.length > 0)
      filtersAnalyticsArray.push(`teams=${filters.teams.length}`);
    if (filters.status && filters.status.length > 0)
      filtersAnalyticsArray.push(`status=${filters.status.sort().join()}`);
    if (filters.objectives && filters.objectives.length > 0)
      filtersAnalyticsArray.push(
        `objectives=${filters.objectives.sort().join()}`
      );
    if (filters.label_ids && filters.label_ids.length > 0)
      filtersAnalyticsArray.push(
        `label_ids=${filters.label_ids.sort().join()}`
      );
    if (filters.due_date) {
      const one_day = 1000 * 60 * 60 * 24;
      const currentDate = new Date();
      const dueDate = new Date(filters.due_date);
      const timeDifference = dueDate.getTime() - currentDate.getTime();
      const daysDifference = Math.round(timeDifference / one_day);
      filtersAnalyticsArray.push(`due_date=${daysDifference}`);
    }
  }
  return `Filter?${filtersAnalyticsArray.join('&')}`.toLowerCase();
};
